var modal_form = ( function( $ ) {

	var $forms;

	var _init = function() {
		$forms = $( '.crate-form[method="POST"]' );

		$forms.on( 'new_tab', _close_modal );
	};

	var _close_modal = function( e ) {
		var $form = $( e.target );
		var $modal = $form.parents( '.crate-modal' );
		var $body = $( 'body' );

		$body.removeClass( 'modal-open' );
		$body.find( '.overlay' ).fadeOut();
		$modal.fadeOut();
	};

	$( document ).ready( _init );

} )( jQuery );